import React from 'react';
import {Link} from 'react-router';
import sortBy from 'lodash/sortBy';
import {prefixLink} from 'gatsby-helpers';
import {rhythm} from 'utils/typography';
import Helmet from "react-helmet";
import access from 'safe-access';
import {config} from 'config';
import include from 'underscore.string/include';
import Bio from 'components/Bio';

import Paper from 'material-ui/Paper';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class SiteIndex extends React.Component {
    render() {
        console.log(this.props.route);
        const pageLinks = [];
        // Sort pages.
        const sortedPages = sortBy(this.props.route.pages, (page) =>
            access(page, 'data.date')
        ).reverse();
        sortedPages.forEach((page) => {
            // Posts are those with md extension that are not 404 pages OR have a date (meaning they're a react component post).
            if (access(page, 'file.ext') === 'md' && !include(page.path, '/404') || access(page, 'data.date')) {
                const title = access(page, 'data.title') || page.path;
                pageLinks.push(
                    <li
                        key={page.path}
                        style={{
                            marginBottom: rhythm(1 / 4),
                        }}
                    >
                        <Link style={{boxShadow: 'none'}} to={prefixLink(page.path)}>{title}</Link>
                    </li>
                )
            }
        });
        return (
            <MuiThemeProvider>
                <div style={{
                    backgroundColor: '#FAFAFA',
                    height: '100%',
                    width: '100%',
                    position: `fixed`,
                    margin: '0'
                }}>
                    <Helmet
                        title={config.blogTitle}
                        meta={[
                            {"name": "description", "content": "Sample blog"},
                            {"name": "keywords", "content": "blog, articles"},
                        ]}
                    />
                    <Paper style={{
                        margin: '50px 0 0 0',
                        textAlign: "center",
                        paddingTop: '10px',
                        height: 220,
                        backgroundColor: '#FFFFFF',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0
                    }}>
                        <h1>Ben Schwab</h1>
                        <Link
                            to={{
                                pathname: prefixLink("/blog/android/"),
                            }}
                            style={{marginRight: '10px' }}
                        >
                            Android
                        </Link>
                        <Link
                            to={{
                                pathname: prefixLink("/blog/thoughts/"),
                            }}
                            style={{marginRight: '10px' }}
                        >
                            Thoughts
                        </Link>
                    </Paper>
                </div>
            </MuiThemeProvider>
        )
    }
}

SiteIndex.propTypes = {
    route: React.PropTypes.object,
};

export default SiteIndex



// WEBPACK FOOTER //
// ./index.js